import { Button } from '@strata/react-buttons';
import { FileUploadFormik } from '@strata/react-file-upload';
import { Form, Formik } from 'formik';

import { CapturedDataListener } from 'components/intakeForm/CapturedDataListener';
import { useInputFocusRef } from 'components/intakeForm/FormHelpers';
import { type IntakeFormSectionProps } from 'components/intakeForm/IntakeFormSectionProps';
import { PointOfContactInputs } from 'components/intakeForm/PointOfContactInputs';
import { IntakeSource } from 'services/constants';
import { useAppDispatch, useAppSelector } from 'store';
import { FormSections, IntakeFormSectionSchemas } from 'store/intakeForm/intakeFormSchema';
import { updateCapturedData } from 'store/intakeForm/intakeFormSlice';
import { goToNextSection } from 'store/intakeForm/intakeFormThunks';

const Section = FormSections.POINT_OF_CONTACT;

export const PointOfContact = ({ isOpen }: IntakeFormSectionProps) => {
    const dispatch = useAppDispatch();
    const { activeSection, capturedData } = useAppSelector((state) => state.intakeForm);

    const intakeSourceRef = useInputFocusRef(isOpen, activeSection, Section);

    return (
        <Formik
            initialValues={capturedData[Section]}
            enableReinitialize
            validateOnMount
            validationSchema={IntakeFormSectionSchemas[Section]}
            onSubmit={(values) => {
                dispatch(updateCapturedData({ [Section]: values }));
                dispatch(goToNextSection(Section));
            }}
        >
            {(formik) => (
                <Form className="sds_intake-form-section">
                    <CapturedDataListener section={Section} isOpen={isOpen} />
                    <PointOfContactInputs intakeSourceRef={intakeSourceRef} />
                    {formik.values.intakeSource === IntakeSource.FAX && (
                        <FileUploadFormik
                            id="faxAttachment"
                            label="Fax Attachment"
                            accept="application/pdf"
                            onAddFiles={async (files) => {
                                await formik.setFieldValue('uploadedFaxAttachment', [
                                    ...((formik.values.uploadedFaxAttachment ?? []) as File[]),
                                    ...files,
                                ]);
                            }}
                            onRemoveFile={async (filename) => {
                                await formik.setFieldValue(
                                    'uploadedFaxAttachment',
                                    formik.values.uploadedFaxAttachment?.filter(
                                        (file: File) => file.name !== filename,
                                    ),
                                );
                            }}
                        />
                    )}
                    <Button
                        intent={Button.Intent.PRIMARY}
                        id="point-of-contact-continue-button"
                        label="Continue"
                        type="submit"
                        disabled={!formik.isValid}
                    />
                </Form>
            )}
        </Formik>
    );
};
